// Load YouTube API
if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  
  window.onYouTubeIframeAPIReady = function() {
    window.dispatchEvent(new CustomEvent('youtube:api:ready'));
  }; 